"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var react_i18next_1 = require("react-i18next");
var NewAppModal_module_css_1 = __importDefault(require("./NewAppModal.module.css"));
var q_play_core_1 = require("@nordicscreen/q-play-core");
var react_admin_1 = require("react-admin");
var AjaxProvider_1 = __importDefault(require("@/functions/AjaxProvider"));
var Checkbox_1 = __importDefault(require("@/Components/common/Checkbox"));
var NewAppModal = function (_a) {
    var isShown = _a.isShown, toggle = _a.toggle, fetchVersions = _a.fetchVersions;
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var _b = (0, react_1.useState)(""), name = _b[0], setName = _b[1];
    var _c = (0, react_1.useState)("webapp"), type = _c[0], setType = _c[1];
    var _d = (0, react_1.useState)(""), header = _d[0], setHeader = _d[1];
    var _e = (0, react_1.useState)(true), visible = _e[0], setVisible = _e[1];
    var _f = (0, react_1.useState)(false), isSaving = _f[0], setIsSaving = _f[1];
    var logger = q_play_core_1.logManager.getLogger();
    var refresh = (0, react_admin_1.useRefresh)();
    var dataProvider = (0, AjaxProvider_1.default)("/api");
    var handleNameChange = function (event) { return setName(event.target.value); };
    var handleTypeChange = function (event) { return setType(event.target.value); };
    var handleHeaderChange = function (event) { return setHeader(event.target.value); };
    var handleVisibleChange = function (event) { return setVisible(event.target.checked); };
    var handleSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var appData, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    appData = {
                        name: name,
                        type: type,
                        header: header,
                        visible: visible,
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    setIsSaving(true);
                    return [4 /*yield*/, dataProvider.create("apps", { data: appData })];
                case 2:
                    _a.sent();
                    refresh();
                    return [4 /*yield*/, fetchVersions()];
                case 3:
                    _a.sent();
                    toggle();
                    return [3 /*break*/, 6];
                case 4:
                    error_1 = _a.sent();
                    logger.error("Error creating app:", error_1);
                    return [3 /*break*/, 6];
                case 5:
                    setIsSaving(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        if (!isShown) {
            setName("");
            setHeader("");
            setVisible(true);
        }
    }, [isShown]);
    var body = (react_1.default.createElement("div", { className: NewAppModal_module_css_1.default.body },
        react_1.default.createElement("div", { className: NewAppModal_module_css_1.default["form-group"] },
            react_1.default.createElement("label", null, t("Name")),
            react_1.default.createElement(q_play_components_1.Input, { type: "text", value: name, onChange: handleNameChange, placeholder: t("Enter app name"), dataCy: "appNameInput" })),
        react_1.default.createElement("div", { className: NewAppModal_module_css_1.default["form-group"] },
            react_1.default.createElement("label", null, t("Header")),
            react_1.default.createElement(q_play_components_1.Input, { type: "text", value: header, onChange: handleHeaderChange, placeholder: t("Enter header"), dataCy: "appHeaderInput" })),
        react_1.default.createElement("div", { className: NewAppModal_module_css_1.default["form-group"] },
            react_1.default.createElement("label", null, t("Type")),
            react_1.default.createElement(q_play_components_1.Select, { value: type, onChange: handleTypeChange, className: NewAppModal_module_css_1.default.select },
                react_1.default.createElement("option", { value: "webapp" }, t("Web App")),
                react_1.default.createElement("option", { value: "webcapture" }, t("Web Capture")),
                react_1.default.createElement("option", { value: "dataapp" }, t("Data App")))),
        react_1.default.createElement("div", { className: NewAppModal_module_css_1.default["form-group-checkbox"] },
            react_1.default.createElement("label", null, t("Visible")),
            react_1.default.createElement(Checkbox_1.default, { checked: visible, onChange: handleVisibleChange }))));
    var customHeader = (react_1.default.createElement("div", { className: "ns-font-family-bold", style: { fontSize: "20px", color: "var(--info-color)" } },
        react_1.default.createElement("div", { style: { color: "var(--info-color)" } },
            react_1.default.createElement("p", null, t("New App")))));
    var footer = (react_1.default.createElement("div", null,
        react_1.default.createElement(q_play_components_1.Button, { text: t("Save"), onClick: handleSave, disabled: !name || !type || !header || isSaving, isLoading: isSaving, dataCy: "saveAppButton" })));
    return (react_1.default.createElement(q_play_components_1.Modal, { isShown: isShown, onClose: toggle, header: customHeader, body: body, footer: footer, dialogClassName: NewAppModal_module_css_1.default["modal-content"], centered: true }));
};
exports.default = NewAppModal;
